import {Referral, TreatmentOffered} from "../../referral";
import {Observable} from "rxjs";
import {SelectField, SelectFieldProps} from "evergreen-ui";
import {Controller, useFormContext} from "react-hook-form";
import {ValidationMessage} from "../../common";
import React from "react";
import {OfferFormInput} from "./OfferForm";
import {useObservable} from "../../rxsupport";

type TreatmentOfferedInputProps = {
    referral: Referral;
    isSubmitting$: Observable<boolean>;
} & SelectFieldProps;

type TreatmentOfferedOption = {
    label: string,
    value: TreatmentOffered
}

const options: TreatmentOfferedOption[] = [
    {
        label: "Caregiver Mediated",
        value: TreatmentOffered.Caregiver_Mediated
    },
    {
        label: "Practitioner Mediated",
        value: TreatmentOffered.Practitioner_Mediated
    },
    {
        label: "Caregiver and Practitioner Mediated",
        value: TreatmentOffered.Caregiver_And_Practitioner_Mediated
    }
];

export const TreatmentOfferedInput = ({
                                          referral,
                                          isSubmitting$,
                                          ...selectProps
                                      }: TreatmentOfferedInputProps) => {

    const {
        control,

        formState: {
            errors,
        },
    } = useFormContext<OfferFormInput>();

    const sending = useObservable(isSubmitting$, false);

    const validationRules = {
        required: {
            message: 'This field is required.',
            value: true,
        }
    };

    return (
        <Controller
            name='treatmentOffered'
            control={control}
            rules={validationRules}
            render={({field: {onChange, onBlur, value}}) => {
                const props = {
                    maxWidth: '24em',
                    label: 'Treatment Offered',
                    ...selectProps,
                    onChange,
                    onBlur,
                    value: value ? value : undefined,
                    disabled: sending,
                    isInvalid: !!errors.treatmentOffered?.message,
                    validationMessage: <ValidationMessage error={errors.treatmentOffered}/>,
                }
                return <SelectField {...props}>
                    <option value=''/>
                    {
                        options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)
                    }
                </SelectField>;
            }}
        />
    );
}
